// GlobalNotificationBinder.js
import { useEffect } from "react";
import { useNotification } from "./NotificationContext";

export default function GlobalNotificationBinder() {
  const { showNotification } = useNotification();

  useEffect(() => {
    // console.log("GlobalNotificationBinder mounted");
    window.showNotification = showNotification;
  }, [showNotification]);

  return null; // This component renders nothing
}
